import { render } from "./dashCvView.vue?vue&type=template&id=61d62c72"
import script from "./dashCvView.vue?vue&type=script&lang=js"
export * from "./dashCvView.vue?vue&type=script&lang=js"

import "./dashCvView.vue?vue&type=style&index=0&id=61d62c72&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__